module.exports = __webpack_public_path__ + "img/CS-Lite-Plus-Repairing.ac52cf7f.jpg";